import styled from 'styled-components'

export const ImportantMailWrapper = styled.div`
 margin-bottom: 20px;
 margin-top: 20px;
`
export const ImportantMailInformation = styled.div`
margin-bottom: 10px;
img {
  margin-right: 8px;
}
`
